import { Analytics } from 'Shared/utils/client';
import { Row } from '@viewup/ui';
import { mainSwiperPaginationCss } from 'app/_components/Main/_shared/swiperPagination.const';
import { useGetBanners } from 'app/_components/Main/api';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { useCallback, useRef } from 'react';
import type { Swiper as SwiperClass } from 'swiper';
import { Autoplay, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';

export const EventBanner = () => {
  const router = useRouter();
  const swiperRef = useRef<SwiperClass | null>(null);
  const { data } = useGetBanners();

  const updateSwiperAutoHeight = useCallback(() => {
    requestAnimationFrame(() => {
      const swiper = swiperRef.current;

      if (!swiper || swiper.destroyed || !swiper.params) return;

      swiper.update();
      swiper.updateAutoHeight(0);
    });
  }, []);

  return (
    <Row br={12} css={mainSwiperPaginationCss} height='max-content' position='relative'>
      <Swiper
        autoHeight
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        modules={[Pagination, Autoplay]}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        pagination={{ clickable: true }}
        spaceBetween={20}
        style={{ height: 'max-content', paddingBottom: 36, width: '100%' }}
      >
        {data?.data.map((data, index) => (
          <SwiperSlide
            key={data.bannerUuid}
            onClick={() => {
              Analytics.getInstance().track('MAIN_BANNER', { index });
              if (data.linkType === 'blank') {
                return window.open(data.link);
              }
              return router.push(data.link || '');
            }}
            style={{
              borderRadius: 12,
              cursor: 'pointer',
              display: 'flex',
              overflow: 'hidden',
            }}
          >
            <Image
              alt={'banners'}
              height={113}
              onLoad={updateSwiperAutoHeight}
              priority
              src={data.image}
              style={{
                height: 'auto',
                width: '100%',
              }}
              unoptimized
              width={392}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </Row>
  );
};
